import React from 'react'
import PropTypes from 'prop-types'

const parseVideoId = (url) => url.split('v=')[1]

const YoutubeVideo = ({ videoUrl }) => {
  const videoId = parseVideoId(videoUrl)

  if (!videoId) return null

  return (
    <iframe
      className="video-frame"
      title="youtube-video"
      maxWidth="560"
      width="100%"
      height="315"
      src={`https://www.youtube.com/embed/${parseVideoId(videoUrl)}?rel=0&showinfo=0`}
      frameBorder="0"
      allow="encrypted-media"
      allowFullScreen
    />
  )
}

YoutubeVideo.propTypes = {
  videoUrl: PropTypes.string.isRequired,
}

export default YoutubeVideo



// WEBPACK FOOTER //
// ./src/browser/components/YoutubeVideo.js